/* tslint:disable:no-submodule-imports */
import { MapEvent } from 'ol';
import { getBottomLeft, getTopRight } from 'ol/extent';
import { connect } from 'react-redux';
import { Kartutsnitt } from '@/domain/kart/Kartutsnitt';
import React from 'react';
import { MapContext } from '@/state/context/MapContext';
import { mapMoved, mapMovedT, mapNavigationStarted } from '@/actions/mapActions';
import { debounce } from 'lodash-es';

interface DispatchProps {
    mapMoved: (center: [number, number], zoom: number, kartutsnitt: Kartutsnitt) => void;
    mapNavigationStarted: () => void;
}

type Props = DispatchProps;

class MapMovedHandler extends React.Component<
    Props,
    Record<string, never>,
    typeof MapContext
> {
    static contextType = MapContext;
    declare context: React.ContextType<typeof MapContext>;

    componentDidMount() {
        this.context.map.on('movestart', this.mapNavigationStartedHandler);
        this.context.map.on('moveend', this.debounce);
    }

    componentWillUnmount() {
        this.context.map.un('movestart', this.mapNavigationStartedHandler);
        this.context.map.un('moveend', this.debounce);
        this.debounce.cancel();
    }

    render() {
        return null;
    }

    private mapMovedHandler = (event: MapEvent) => {
        const map = event.map;
        const view = map.getView();
        const center = view.getCenter();
        const zoom = view.getZoom();
        if (!center || zoom === undefined) {
            return;
        }
        const extent = view.calculateExtent(map.getSize());
        const bottomLeft = getBottomLeft(extent);
        const topRight = getTopRight(extent);
        this.props.mapMoved(
            [Math.round(center[0]), Math.round(center[1])],
            Math.round(zoom),
            new Kartutsnitt(bottomLeft[0], bottomLeft[1], topRight[0], topRight[1])
        );
    };

    private mapNavigationStartedHandler = () => {
        this.debounce.cancel();
        this.props.mapNavigationStarted();
    };

    private debounce = debounce(this.mapMovedHandler, 500);
}

const mapDispatchToProps = {
    mapMoved,
    mapNavigationStarted,
};

export const MapMoved = connect(null, mapDispatchToProps)(MapMovedHandler);
